import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent{

    url : string = '/';

    loaded : boolean = false;

    public popup : boolean = false;

    constructor(private router: Router) {

        //페이지 이동시 전체메뉴 닫아주기
        router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe((ev: NavigationEnd) => {
                console.debug('ev', ev);
                if(ev.url == this.url){
                    window.location.reload();
                }
                this.url = ev.url;
                if(this.url != '/'){
                    this.loaded = true;
                    // top버튼 familySite
                    setTimeout(() => {
                        $('.btn_top').on('mouseenter', function () {
                            console.log('enter');
                            $(this).addClass('zoom');
                        }).on('mouseleave', function () {
                            $(this).removeClass('zoom');
                        });
                        $('.btn_top').off('click').on('click', function () {
                            $('body,html').animate({scrollTop: 0}, 800);
                            return false;
                        });
                    
                        $('.familySite').find('.btn_family').on('click',function(){
                            $(this).toggleClass('on');
                            $(this).siblings('.list').stop().slideToggle(400);
                        });

                        $('.ft_info .btn_privacy').off('click').on('click', function(){
                            layerPopControl('privacy');
                            return false;
                        });
                    },300);
                }else{
                    this.loaded = false;
                }
                console.debug('this.loaded', this.loaded);
            })
        }
    ngOnInit(){
        this.url = this.router.url;
        if(this.url != '/'){
            this.loaded = true;
        }else{
            this.loaded = false;
        }

        setTimeout(() => {
            $('.ft_info .btn_privacy').off('click').on('click', function(){
                layerPopControl('privacy');
                return false;
            });
        }, 300);

    }

}
declare var $ : any;
declare var layerPopControl : any;